const { Cookie } = require("./src/utils/Cookie");
const { Receptor } = require("./src/services/receptor");

exports.onClientEntry = () => {

  const defaultDatalayer = {
    cookie: Cookie.get("Bearer") ?? "",
    url: document.location.href,
    url_origem: document.referrer,
    cookie_id: Cookie.get("ANE_DEVICE_ID") ?? "",
    data_criacao: Date.now(),
    itm_source: localStorage.getItem("itm_source") || "",
    itm_medium: localStorage.getItem("itm_medium") || "",
    itm_campaign: localStorage.getItem("itm_campaign") || "",
    utm_source: localStorage.getItem("utm_source") || "",
    utm_medium: localStorage.getItem("utm_medium") || "",
    utm_campaign: localStorage.getItem("utm_campaign") || "",
  };

  /**
   * Adicionando botão flutuando nas tags via scrip do estaticos
   * @task - SA-240
   */
  const scripts = [
    "https://estaticos.novaescola.org.br/chat-wpp-popover.js",
    "https://estaticos.novaescola.org.br/localizacao-popup.js",
    "https://estaticos.novaescola.org.br/whatsapp-popover.js"
  ];

  scripts.forEach(src => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.defer = true;

    if (src.includes("whatsapp-popover")) {
      script.setAttribute("data-event", "subhome jornalismo");
      script.setAttribute("data-project", "JORNALISMO");
      script.setAttribute("data-href", "https://api.whatsapp.com/send/?phone=5511999732391&text=Ol%C3%A1%2C+quero+planejar+aulas&type=phone_number&app_absent=0")
    }

    document.body.appendChild(script);
  });

  const audimaScript = document.createElement("script");
  audimaScript.src = "https://menu.audima.co/accessibility.js?position=bottomRight";
  audimaScript.onload = () => {
    const checkBtn = setInterval(() => {
      const audimaBtn = document.querySelector("#accessibility-menu");
      if (audimaBtn) {
        audimaBtn.style.bottom = "170px";
        clearInterval(checkBtn);
      }
    }, 200);
  };

  audimaScript.defer = true;
  document.body.appendChild(audimaScript);

  window.defaultDatalayer = defaultDatalayer;
  Receptor.send({ ...defaultDatalayer });
};
